import React, {Component} from 'react';
import axios from "axios";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import Loader from "../Loader";

import './ads.css';


class AlibabaAds extends Component {
    state = {
        ads: [],
        loading: true
    }

    componentWillMount() {
        let url = "";
        if (this.props.category) {
            url = `${process.env.REACT_APP_BACKEND_URL}/promotions/alibaba-products`;
            url = url + `?category=${this.props.category}`;
        } else
            url = `${process.env.REACT_APP_BACKEND_URL}/promotions/alibaba`;
        axios.get(url)
            .then((res) => {
                this.setState({ads: res.data, loading: false});
            }).catch(err => console.error(err))
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let url = "";
        this.setState({loading: true});
        if (nextProps.category) {
            url = `${process.env.REACT_APP_BACKEND_URL}/promotions/alibaba-products`;
            url = url + `?category=${nextProps.category}`;
        } else
            url = `${process.env.REACT_APP_BACKEND_URL}/promotions/alibaba`;
        axios.get(url)
            .then((res) => {
                this.setState({ads: res.data, loading: false});
            }).catch(err => console.error(err))
    }

    render() {
        const {ads, loading} = this.state;
        if (ads.length === 0)
            return null;
        if (ads.length > 0)
            return (
                <div>
                    <div
                        style={{flex: 1}}
                        className="container-fluid py-4"
                        // className={classes.root}
                    >
                        <h6>Promotions</h6>
                        <hr/>
                        {loading === true ?
                            <Loader/>
                            :
                            <GridList style={{flexWrap: 'nowrap'}} cols={2.5}>
                                {ads.map((tile, index) => (
                                    <GridListTile className="ads-box" style={{
                                        width: ' 28%',
                                        height: '230px'
                                    }} key={index}>
                                        <a target="_blank" href={tile.href}>
                                            <img width="300" height="250" src={tile.img}
                                                 alt={tile.title ? tile.title : 'Alibaba'}/>
                                            <GridListTileBar
                                                title={'Shop Now'}
                                                subtitle={tile.price ? `£${tile.price}` : null}
                                            />
                                        </a>
                                    </GridListTile>
                                ))}
                            </GridList>
                        }
                    </div>
                </div>
            )
    }

}

export default AlibabaAds;



// WEBPACK FOOTER //
// ./src/components/Ads/AlibabaAds.js